<template>
    <div>
        <!-- voteStatus  投票状态    1：未开始    2：进行中    3：已结束	 -->
        <el-link v-if="row.voteStatus < 3 && row.choiceStatus === 1" v-text-lbl="'join'" type="text" @click="vote">参与</el-link>
        <el-link v-if="row.voteStatus < 3 && row.choiceStatus === 1" v-text-lbl="'join'" type="text" @click="waive">弃票</el-link>
        <el-link v-else-if="row.choiceStatus == 2" v-text-lbl="'look'" type="text" @click="lookInfo">投票结果</el-link>
        <el-link v-else v-text-lbl="'abstained'" disabled>弃票</el-link>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        row: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'voteManage',
            id: '',
            account: '',
            orgCode: '',
            voteResult: {},
            vo: {},
            voteTypeArr: [this.$tx('hygl.voteManage.Radio', '单选'), this.$tx('hygl.voteManage.multipleChoice', '多选')],
            totleVoteNum: '',
            myChoiceList: {},
            choiceTotle: 0,
            resInfoList: []
        }
    },
    computed: {},
    created() {},
    beforeDestroy() {},
    mounted() {},
    methods: {
        vote() {
            // 打开新页面
            window.open(`/#/commonHeader?workform=@/wapp/hygl/voteManage/components/HyglNewToupiao&header=${this.row.voteTheme}&id=${this.row.voteId}
            &account=${this.row.account}&orgCode=${this.row.orgCode}&canEdit=yes&resultId=${this.row.id}&logoTitle=${encodeURIComponent(this.$tx('hygl.voteManage.resolutionVoting', '决议投票'))}`)
        },
        waive() {
            this.$confirm('是否确认放弃投票?', '操作提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.row.choiceStatus = 5
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/hygl/voteResult/update`,
                    method: 'PUT',
                    data: this.row
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.$bus.emit('refreshListData')
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        lookInfo() {
            window.open(`/#/commonHeader?workform=@/wapp/hygl/voteManage/components/HyglNewToupiao&header=${this.row.voteTheme}&id=${this.row.voteId}
            &account=${this.row.account}&orgCode=${this.row.orgCode}&canEdit=no&resultId=${this.row.id}&logoTitle=${encodeURIComponent(this.$tx('hygl.voteManage.resolutionVoting', '决议投票'))}`)
        }
    }
}
</script>

<style scoped lang="scss">
.subject {
    margin: 20px 0;
    .voteInfo {
        border: 1px solid #e0e0e0;
        border-bottom: none;
        list-style: none;
        padding: 0;
    }
    li {
        border-bottom: 1px solid #e0e0e0;
        line-height: 40px;
        padding-left: 10px;
        padding-right: 10px;
        z-index: 0;
        position: relative;
        overflow: hidden;
    }
    label {
        font-weight: 400;
    }
}
.tpprocess {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    background: #c4e0ff;
}
</style>
